<p-panel header="{{ title }}" [toggleable]="true">
  <div class="p-p-0">
    <div id="linechart" class="" [ngStyle]="{ height: height }"></div>
  </div>
</p-panel>
